module.exports = __webpack_public_path__ + "img/pine.be5030ca.webp";